<template>
    <div>
        <div class="content-wrapper">
            <!-- Content Header (Page header) -->
            <section class="content-header">
                <h1>
                    Service d'envoi de SMS
                    <small></small>
                </h1>
                <ol class="breadcrumb">
                    <li>
                        <router-link :to="{ name: 'Dashboard'}">
                            <i class="fa fa-dashboard"></i>
                            Accueil
                        </router-link>
                    </li>
                    <li><a href="#">Outils</a></li>
                    <li class="active">Service d'envoi de SMS</li>
                </ol>
            </section>

            <section class="content">
                <div class="row">
                    <div class="col-md-12">
                        <b-alert show>
                            <span v-if="spryng">Il vous reste {{Math.floor(balance/ 1.2)}} SMS disponibles. <a href="https://www.spryng.be">Recharger?</a></span>
                            <span v-if="smsfactor">Il vous reste {{balance}} SMS disponibles. <a href="https://www.smsfactor.be">Recharger?</a></span>
                        </b-alert>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                        <div class="box box-primary">
                            <div class="overlay"
                                 v-if="loading">
                                <i class="fa fa-refresh fa-spin"></i>
                            </div>
                            <div class="box-header with-border">
                                <h3 class="box-title">Contenu du sms</h3>
                            </div><!-- /.box-header -->
                            <div class="box-body">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="form-group">
                                            <label for="contenuSMS">Objet du courrier</label>
                                            <b-form-textarea
                                                    id="textarea"
                                                    v-model="sms"
                                                    placeholder="Contenu du sms..."
                                                    rows="8"
                                            ></b-form-textarea>
                                            <div class="col-12">
                                                <div class="col-md-3" :class="{'text-red': getNombreSMS()!=1 }">
                                                    <i class="fa fa-warning text-red" v-if=" getNombreSMS()!=1"></i>
                                                    {{ getNombreSMS() }} SMS
                                                </div>
                                                <div class="col-md-9 text-right">
                                                    {{ sms.length }} caractères (160 caractères par SMS)
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="box-footer">
                                <div>
                                    <div class="col-md-6">
                                        <span v-if="spryng">Coût estimé de l'envoi: {{ Math.ceil((getNombreSMS() * 0.1597 * getMemberToSMS.length)*100)/100 }}€</span>
                                        <span v-if="smsfactor">Coût estimé de l'envoi: {{ Math.ceil((getNombreSMS() * 0.084 * getMemberToSMS.length)*100)/100 }}€</span>
                                    </div>
                                    <div class="col-md-6">
                                        <button
                                                @click="sendSMS()"
                                                :disabled="sms.length<1 || sms.length>600 || hasNumberErrors()"
                                                type="button" class="btn btn-primary pull-right" style="margin-right: 5px;">
                                            <i class="fa fa-send-o"></i> Envoyer SMS
                                        </button>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                        <div class="box box-primary">
                            <div class="overlay"
                                 v-if="loading">
                                <i class="fa fa-refresh fa-spin"></i>
                            </div>
                            <div class="box-header with-border">
                                <h3 class="box-title">Recherche</h3>
                            </div><!-- /.box-header -->
                            <div class="box-body">
                                <div class="form-group"
                                     :class="">
                                    <label for="searchGeneral">Recherche de membres</label>
                                    <v-select v-model="recherche"
                                              label="fullName"
                                              :filterable="false"
                                              :taggable="false"
                                              :debounce="250"
                                              :on-search="SearchMembersResponse"
                                              :on-change="onSelect"
                                              :options="ArrayMembersSearch">
                                        <template slot="option" slot-scope="props">
                                            <span :class="props.item.licencie? 'text-green' : 'text-red'">{{props.item.fullName +" - "+props.item.club.club}}</span>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="box box-primary">
                            <div class="box-header with-border">
                                <b-col md="9" class="my-1">
                                    <h3 class="box-title">Listing des membres: {{getMemberToSMS.length}}
                                        membre{{getMemberToSMS.length>1 ? 's':''}} sélectionné{{getMemberToSMS.length>1 ? 's':''}}</h3>
                                </b-col>
                                <b-col md="3" class="my-1">

                                    <b-form-input v-model="filter" style="height: 28px;" placeholder="Rechercher..."></b-form-input>
                                </b-col>

                            </div>
                            <div class="box-body">
                                <b-table
                                        id="tableListingAllMember"
                                        v-if=""
                                        responsive bordered striped hover
                                        :items="getMemberToSMS"
                                        :fields="columnsMembers"
                                        :filter="filter"
                                        :current-page="pagination_meta.current_page"
                                        :per-page="pagination_meta.per_page"
                                        :sort-by.sync="sortBy"
                                        :sort-desc.sync="sortDesc"
                                        :no-local-sorting="true"
                                        :no-sort-reset="true"
                                        :empty-text="'Aucun résultat'"
                                        :empty-filtered-text="'Aucun résultat'"
                                        foot-clone
                                        show-empty
                                >
                                    <template slot="nom" slot-scope="data">
                                        <router-link :to="{ name: 'Member', params: { member_id: data.item.id }}">
                                            {{ data.item.nom}}
                                        </router-link>
                                    </template>

                                    <template slot="prenom" slot-scope="data">
                                        <router-link :to="{ name: 'Member', params: { member_id: data.item.id }}">
                                            {{ data.item.prenom}}
                                        </router-link>
                                    </template>
                                    <template slot="club" slot-scope="data">
                                        <router-link :to="{ name: 'Club', params: { club_id: data.value.id }}">
                                            {{data.value.club}}
                                        </router-link>
                                    </template>
                                    <template slot="gsm" slot-scope="data">
                                        <i class="fa fa-warning text-red" v-if="hasErrorNumberGSM(data.item.gsm)"></i>
                                        <span :class="{'text-red':hasErrorNumberGSM(data.item.gsm)}">{{data.item.gsm}}</span>

                                    </template>
                                    <template slot="actions" slot-scope="data">
                                        <button @click.prevent="deleteMemberFromSMS(data.item.id)"
                                                class="btn btn-default padding2">
                                            <i class="glyphicon glyphicon-remove"></i>
                                        </button>
                                    </template>
                                </b-table>
                                <b-pagination size="md"
                                              :total-rows="getMemberToSMS.length"
                                              v-model="pagination_meta.current_page"
                                              :per-page="pagination_meta.per_page">
                                </b-pagination>
                                <button
                                        @click="emptyMemberToSMS"
                                        :disabled="getMemberToSMS.length==0"
                                        type="button" class="btn btn-primary pull-right" style="margin-right: 5px;">
                                    <i class="fa fa-trash-o"></i> Vider la liste
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

    </div>
</template>

<script type="text/babel">
    import {mapGetters, mapActions} from 'vuex'
    import vSelect from '../Communs/vSelect/index'

    const axios = require('axios');
    const axiosSpryng = axios.create({
        timeout: 1000,
        headers: {
            'Accept': "application/json",
            'Authorization': "Bearer " + process.env.SPRYNG_TOKEN
        }
    });
    const axiosSmsFactor = axios.create({
        timeout: 1000,
        headers: {
            'Accept': "application/json",
            'Authorization': "Bearer " + process.env.SMSFACTOR_TOKEN
        }
    });

    export default {
        data() {
            return {
                spryng: true,
                smsfactor: false,
                sms: "",
                recherche: null,
                ArrayMembersSearch: [],
                loading: false,
                ArrayMemberToSend: [],
                filter: null,
                sortBy: null,
                balance: 0,
                sortDesc: false,
                filter: null,
                previousRequest: null,
                sortDirection: 'asc',
                isBusy: false,
                pagination_meta: {
                    current_page: 1,
                    from: 1,
                    last_page: 1,
                    path: "",
                    per_page: 20,
                    to: 1,
                    total: 0
                },
                columnsMembers: [
                    {
                        label: 'Nom',
                        key: 'nom',
                        sortable: true,
                    },
                    {
                        label: 'Prénom',
                        key: 'prenom',
                        sortable: true,
                    },
                    {
                        label: 'Club',
                        key: 'club',
                        sortable: true,
                    },
                    {
                        label: 'GSM',
                        key: 'gsm',
                        sortable: true,
                    },
                    {
                        label: 'Actions',
                        key: 'actions',
                    },
                ]
            }
        },
        methods: {
            ...mapActions({
                addMemberToSMS: 'addMemberToSMS',
                deleteMemberFromSMS: 'deleteMemberFromSMS',
                emptyMemberToSMS: 'emptyMemberToSMS',
            }),
            hasErrorNumberGSM: function (number) {
                let regex1 = RegExp("^(04)([0-9]{8})$")
                let numerToVerif = number.replace(/\D/g, "")
                if (!regex1.test(numerToVerif))
                    return true
                return false
            },
            hasNumberErrors: function () {
                let error = false
                this.getMemberToSMS.forEach((item) => {
                    if (this.hasErrorNumberGSM(item.gsm))
                        error = true
                })
                return error
            },
            getBalance: function () {
                // console.log(axiosSmsFactor.defaults.headers)

                if (this.spryng)
                    axiosSpryng.get('https://rest.spryngsms.com/v1/balance').then((response) => {
                        this.balance = response.data.amount
                    }, (response) => {
                    });
                else if (this.smsfactor) {
                    axiosSmsFactor.get('//api.smsfactor.com/credits').then((response) => {
                        this.balance = response.data.credits
                    }, (response) => {
                    });
                }
            },
            sendSMS: function () {
                // this.loading=true

                let arrayBy50 = []
                let tempArray = []
                let compteur = 0
                this.getMemberToSMS.forEach((item, index) => {
                    compteur++
                    let onlyNumber = "32" + item.gsm.replace(/\D/g, "").slice(1)
                    tempArray.push(onlyNumber)
                    if (compteur >= 45 || index === this.getMemberToSMS.length - 1) {
                        arrayBy50.push(tempArray.slice(0))
                        tempArray = []
                        compteur = 0
                    }
                })

                arrayBy50.forEach((arrayOfNumber) => {
                    if (this.spryng)
                        axiosSpryng.post('https://rest.spryngsms.com/v1/messages?with[]=recipients', {
                            encoding: "plain",
                            body: this.sms,
                            route: 'business',
                            originator: 'ABFT',
                            recipients: arrayOfNumber,
                        }).then((response) => {
                            this.getBalance()
                            this.loading = false
                            this.balance = response.data.amount
                            this.$noty.success('Les SMS ont bien été envoyés')
                            this.emptyMemberToSMS()
                        }, (response) => {
                            this.getBalance()
                            this.loading = false
                            this.$noty.success('Une erreur a été rencontrée')
                        });
                    else if (this.smsfactor)

                        axiosSmsFactor.post('https://api.smsfactor.com/send/lists/simulate', {
                            "sms": {
                                "message": {
                                    "text": this.sms,
                                    "pushtype": "alert",
                                    "sender": "A.B.F.T.",
                                },
                                "lists": arrayOfNumber.map((item) => {
                                    return {value: item}
                                })
                            }
                        }).then((response) => {
                            this.getBalance()
                            this.loading = false
                            this.balance = response.data.amount
                            this.$noty.success('Les SMS ont bien été envoyés')
                            this.emptyMemberToSMS()
                        }, (response) => {
                            this.getBalance()
                            this.loading = false
                            this.$noty.success('Une erreur a été rencontrée')
                        });
                })


            },
            getNombreSMS: function () {
                if (this.sms.length <= 160)
                    return 1
                else if (this.sms.length >= 161 && this.sms.length <= 304)
                    return 2
                else if (this.sms.length >= 305 && this.sms.length <= 456)
                    return 3
                else if (this.sms.length >= 457 && this.sms.length <= 608)
                    return 4
                else
                    return 'Trop de '
            },
            onSelect: function (item) {
                // console.log(item);
                this.addMemberToSMS({
                    id: item.id,
                    club: item.club,
                    gsm: item.gsm,
                    nom: item.nom,
                    prenom: item.prenom
                })
            },
            SearchMembersResponse: function (search, loading) {
                if (search.length <= 2)
                    return;
                let these = this;
                loading(true)
                this.$http.post(this.getRoute("memberSearch"), {q: search}, {
                    before(request) {
                        if (these.previousRequest)
                            these.previousRequest.abort();
                        these.previousRequest = request;
                    }
                }).then(resp => {
                    loading(false)
                    let idsAlreadyExists = "";
                    this.ArrayMembersSearch = resp.data;
                    // this.getCompetition.participations.forEach((item) => {
                    //     this.ArrayMembersSearch = _.reject(this.ArrayMembersSearch, function (item2) {
                    //         return item.membre.id == item2.id
                    //     });
                    // })
                    // this.ArrayMembersSearch = _.where(this.ArrayMembersSearch, {licencie: true}).concat(_.where(this.ArrayMembersSearch, {licencie: false}))
                })
            },
        },
        computed: {
            ...mapGetters({
                getRoute: 'getRoute',
                getMemberToSMS: 'getMemberToSMS'
            }),
        },
        components: {
            vSelect,
        },
        watch: {},
        mounted() {
            this.$nextTick(() => {
                this.getBalance()
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Outils/EnvoiSMS.vue